import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '+560',
  label: 'Páginas'
}, {
  value: '+80',
  label: 'Protocolos'
}, {
  value: '6',
  label: 'Tomos'
}, {
  value: '6',
  label: 'Bonos'
}];
const tags = ['Detección de señales de salud mental', 'TDAH en consultorio', 'TEA: evaluación y derivación', 'Depresión en adolescentes', 'Ansiedad infantil', 'Abuso físico y sexual', 'Denuncia obligatoria', 'Riesgo suicida adolescente', 'Autolesiones', 'Crisis emocional en consultorio', 'Comunicación con padres', 'Consentimiento en menores', 'Derivación a salud mental', 'Coordinación con escuela', 'Informe para juzgado de familia', 'Ley 26.061 aplicada', 'Documentación legal preventiva', 'Responsabilidad médica en menores'];
export function Stats() {
  return <section className="bg-blue-900 py-12 sm:py-28 text-white relative overflow-hidden" data-id="element-297">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-298"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-teal-500 rounded-full blur-[100px] opacity-20" data-id="element-299"></div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-300">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-16" data-id="element-301">
          <h2 className="text-2xl font-bold tracking-tight sm:text-4xl mb-2 sm:mb-4" data-id="element-302">
            El sistema más completo de salud mental pediátrica para el médico
            argentino
          </h2>
          <p className="text-sm sm:text-xl text-blue-200 font-medium" data-id="element-303">
            Funciona desde tu primera consulta
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8 mb-10 sm:mb-20 max-w-4xl mx-auto" data-id="element-304">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          scale: 1.1
        }} className="text-center cursor-pointer" data-id="element-305">
              <div className="text-4xl sm:text-5xl font-bold text-white mb-1 sm:mb-2 tracking-tight drop-shadow-lg" data-id="element-306">
                {stat.value}
              </div>
              <div className="text-blue-200 font-medium uppercase tracking-wider text-xs sm:text-sm" data-id="element-307">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        <div className="max-w-5xl mx-auto" data-id="element-308">
          <p className="text-center text-xs sm:text-sm font-semibold tracking-wide text-teal-300 uppercase mb-4 sm:mb-6" data-id="element-309">
            Situaciones cubiertas:
          </p>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3" data-id="element-310">
            {tags.map((tag, index) => <motion.span key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.02
          }} whileHover={{
            scale: 1.05,
            backgroundColor: 'rgba(255,255,255,0.2)'
          }} className="inline-flex items-center px-3 py-1.5 sm:px-4 sm:py-2 rounded-full bg-white/10 text-blue-50 text-[10px] sm:text-sm font-medium ring-1 ring-white/20 backdrop-blur-sm cursor-pointer transition-colors" data-id="element-311">
                {tag}
              </motion.span>)}
          </div>
        </div>
      </div>
    </section>;
}